import { render, staticRenderFns } from "./DispersionTable.vue?vue&type=template&id=e07419ba&scoped=true&"
import script from "./DispersionTable.vue?vue&type=script&lang=js&"
export * from "./DispersionTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07419ba",
  null
  
)

export default component.exports